import React, { FC } from 'react'
import { TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import {
  ResidentAppAsideText,
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { QuestionForm } from './QuestionForm'
import { QuestionSuccess } from './QuestionSuccess'
import { QuestionDataLoader } from './QuestionDataLoader'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import routePath from '../../router/routePath'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

export type QuestionViewState = 'form' | 'preview' | 'success'

export const Question: FC = () => {
  const [view, setView] = React.useState<QuestionViewState>('form')
  const { t } = useTranslation(['common', 'question', 'titles'])
  const { frontPagePath } = useContractPaths()
  const location = useLocation()
  const locationState = location.state as { from: string } | null
  const { currentContractId } = useCurrentContract()

  const backPath =
    locationState?.from === 'contact'
      ? routePath.contactInfo.replace(':contractId', currentContractId)
      : frontPagePath

  const backText =
    locationState?.from === 'contact'
      ? t('titles:contactInformation')
      : t('common:views.home')

  return (
    <TitleController title={t('question:headings.question')}>
      <ResidentAppView
        title={t('question:headings.question')}
        backLink={
          <ResidentAppBackLink href={backPath}>{backText}</ResidentAppBackLink>
        }
        aside={
          <ResidentAppAsideText>
            {t('question:texts.instructions')}
          </ResidentAppAsideText>
        }
      >
        <ResidentAppCard>
          <QuestionDataLoader>
            {({ contract, user, userMetadata }) =>
              view === 'success' ? (
                <QuestionSuccess />
              ) : (
                <QuestionForm
                  contract={contract}
                  user={user}
                  userMetadata={userMetadata}
                  view={view}
                  setView={setView}
                />
              )
            }
          </QuestionDataLoader>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
